export enum EditCoachSteps {
  completeProfile = 0,
  addPhoto = 1,
}
